import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import checkImg from "../../assets/images/check_circle.svg";
import { LoginValue } from "../../Actions/LoginPageAction";
import { useDispatch, useSelector } from "react-redux";
import { setProgress } from "../../Actions/progressAction";
import {
  fetchBackupCodes,
  rememberBackupDevice,
  resetBackupCodesState,
} from "../../Actions/BackupCodesActions";
import { resetRememberDeviceState } from "../../reducers/RememberDeviceReducer";
import PropTypes from 'prop-types';

const BackupCodesDialog = ({ open, onCancel }) => {
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const dispatch = useDispatch();
  const { backupCodes, isLoading, error } = useSelector(
    (state) => state.backupCodes
  );
  const rememberDeviceCheck = useSelector(
    (state) => state.rememberDevice.rememberDeviceCheck
  );

  useEffect(() => {
    if (!showSuccessDialog) {
      dispatch(setProgress(60));
    } else {
      dispatch(setProgress(100));
    }
  }, [dispatch, showSuccessDialog]);

  useEffect(() => {
    if (open) {
      dispatch(fetchBackupCodes());
    }
  }, [open, dispatch]);

  const onNext = async () => {
    if (rememberDeviceCheck) {
      await dispatch(rememberBackupDevice());
    }
    dispatch(setProgress(100));
    setShowSuccessDialog(true);
  };

  const handleDone = () => {
    localStorage.setItem("isMFACompleted", "true");
    localStorage.setItem("isAuthenticated", "true");
    localStorage.setItem("lastPath", "/dashboard");
    dispatch(LoginValue(true));
    dispatch(resetRememberDeviceState());
    dispatch(resetBackupCodesState());
  };

  const renderBackupCodes = () => {
    if (error) {
      return <p style={{ color: "red" }}>{error}</p>;
    }

    if (backupCodes.length > 0) {
      return (
        <div>
            <p
              style={{
                fontFamily: "Barlow Semi Condensed",
                fontSize: "16px",
                fontWeight: 400,
                lineHeight: "24px",
                marginBottom: "30px",
                color:"#000"
              }}
               id="keepbackup"
            >
            Keep this backup code somewhere safe but accessible:
          </p>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              width: "243px",
              height: "183px",
                justifySelf: "center",
            }}
             role="list"
            aria-label="Backup codes"
          >
            {backupCodes.map((code, index) => (
                <div
                  key={index}
                   role="listitem"
                  style={{
                    textAlign: "center",
                    fontFamily: "Barlow Semi Condensed",
                    fontSize: "20px",
                    fontWeight: 400,
                    lineHeight: "23px",
                  }}
                >
                {code}
              </div>
            ))}
          </div>
        </div>
      );
    }

    return <p>No backup codes available. Please try generating them again.</p>;
  };
  useEffect(() => {
    if (!isLoading) {
      setTimeout(() => {
        const btn = document.getElementById("backupdailog");
        if (btn) btn.focus();
      }, 200);
    }
  }, [isLoading]);
  useEffect(() => {
    if (showSuccessDialog) {
      setTimeout(() => {
        const btn = document.getElementById("backupdone");
        if (btn) btn.focus();
      }, 500);
    }
  }, [showSuccessDialog]);
  return (
    <>
      {!showSuccessDialog ? (
        <>
          <div className="backup-content">
            {isLoading ? <p>Loading backup codes...</p> : renderBackupCodes()}
          </div>
          <div className="mfa-save">
            <Button variant="outlined" className="cancelBtn" onClick={onCancel}  disableRipple>
              Cancel
            </Button>
            <Button
              className="disabled-button"
              disabled={isLoading || !!error}
              onClick={onNext}
               id="backupdailog"
              disableRipple
            >
              Next
            </Button>
          </div>
        </>
      ) : (
        <div className="succes_modal">
          <img src={checkImg} alt="" />
          <h2>Success</h2>
          <p id="succesmsgone">Your verification is successfully completed.</p>
          <div className="mfa-save">
            <Button
              variant="contained"
              color="primary"
              onClick={handleDone}
              className="done-btn"
               aria-label="Done"
              disableRipple
            >
              Done
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

BackupCodesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default BackupCodesDialog;